import React, { Component } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { URL } from "../../constants/constant";
import { _axios } from "../../plugins/axios";
import moment from "moment";
import TimePicker from "react-bootstrap-time-picker";
import { timeFromInt } from "time-number";
import DependantHeaderSample from "./dependantHeaderSample";

const validMobileRegex = RegExp(/^[6-9]\d{9}$/i);

class DependantRescheduleToSameDay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOTPVerification: false,
      sendOTP: false,
      otpDataId: null,
      phoneNumber: JSON.parse(localStorage.getItem("customer_phoneNumber")),
      showSnack: false,
      messageSnack: "",
      date: JSON.parse(localStorage.getItem("AppointmentDate")),
      currentTime: moment(new Date(JSON.parse(localStorage.getItem("AppointmentDate"))))
        .format("YYYY-MM-DD HH:mm")
        .split(" ")[1]
        .split(":")[0]
        .concat(":00"),
      errors: {
        phoneNumber: "",
      },
    };
  }

  formatDate(date) {
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    return date.getDate() + "-" + months[date.getMonth()] + "-" + date.getFullYear();
  }

  showAlert(message, timeout) {
    this.setState({
      messageSnack: message,
      showSnack: true,
    });
    setTimeout(() => {
      this.setState({
        messageSnack: "",
        showSnack: false,
      });
    }, timeout);
  }

  removeLocalStorage() {
    localStorage.removeItem("AppointmentDate");
    localStorage.removeItem("AppointmentId");
    localStorage.removeItem("City");
    localStorage.removeItem("DID");
    localStorage.removeItem("name");
    localStorage.removeItem("providerOrderId");
  }

  sendOTP() {
    let that = this;
    const url = URL.dev_url;
    _axios
      .post(`${url}sendOTPForUsers`, {
        phonenumber: this.state.phoneNumber.toString(),
        type: "Same_Day_Reschedule_OTP"
      })
      .then(function (response) {
        that.showAlert("OTP sent successfully!", 2500);
        that.setState({
          sendOTP: response.data.success,
          otpDataId: response.data.otpDataId,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  verifyOtp(event) {
    const { name, value } = event.target;
    if (value.length == 4) {
      this.setState({
        otp: value,
      });
    } else {
      console.log("otp..", value);
    }
  }
  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }

  validateTime(time) {
    let date = moment(new Date(JSON.parse(localStorage.getItem("AppointmentDate")))).format("YYYY-MM-DD");
    let dateTime = new Date(date.concat(" ").concat(timeFromInt(time)));
    console.log(dateTime);
    this.setState({
      date: dateTime,
      showOTPVerification: true,
      currentTime: timeFromInt(time),
    });
  }

  RescheduleToSameDay() {
    let that = this;
    let url = URL.dev_url;
    let route = url + "updateorders";
    let city = JSON.parse(localStorage.getItem("City"));
    let DID = JSON.parse(localStorage.getItem("DID"));
    let orderId = JSON.parse(localStorage.getItem("providerOrderId"));
    let phelboDetails = JSON.parse(localStorage.getItem("user_details"));

    _axios
      .post(route, {
        access_token: "trialTest",
        providerOrderId: orderId,
        isSameDayReschedule: true,
        city: city,
        dependantId: DID,
        currentStatusId: 2,
        requestNextStatusId: 21,
        remarks: `Reschedule Same Day by ${phelboDetails.name} (ID -${phelboDetails.phleboId}`,
        appointmentTime: `${moment(new Date(JSON.parse(localStorage.getItem("AppointmentDate")))).format("YYYY-MM-DD HH:mm")}`,
        newAppointmentTime: `${moment(that.state.date).format("YYYY-MM-DD HH:mm")}`,
        doneBy: `${phelboDetails.email} - ${phelboDetails.name} `,
        executeAtPatientLevel: true,
      })
      .then(function (response) {
        if (response.data.success) {
          that.showAlert(response.data.message, 2500);
          that.removeLocalStorage();
          that.props.history.push("/dependantOrders");
        } else if (!response.data.success) {
          that.showAlert(response.data.message, 2500);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;
    let userDetails = JSON.parse(localStorage.getItem("user_details"));

    switch (name) {
      case "phoneNumber":
        errors.phoneNumber =
          validMobileRegex.test(value) && value !== userDetails.phonenumber1 ? this.setState({ phoneNumber: value }) : "Phone Number must be valid";
        break;
      default:
        break;
    }

    this.setState({ errors, [name]: value });
  };

  handleSubmit = (event) => {
    let that = this;
    event.preventDefault();

    let url = URL.dev_url;
    let route = url + "verifyotp";

    _axios
      .post(route, {
        phonenumber: this.state.phoneNumber,
        otp: this.state.otp,
        otpEvent: "rescheduleSameDay",
        otpDataId: this.state.otpDataId ? this.state.otpDataId : null,
      })
      .then(function (response) {
        if (response.data.otpStatus) {
          that.setState(
            {
              showMessage: response.data.message,
            },
            () => {
              that.RescheduleToSameDay();
            }
          );
        } else if (!response.data.otpStatus) {
          that.showAlert("Invalid OTP !", 2500);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  render() {
    const { errors } = this.state;
    return (
      <div className="order-details-dashboard">
        <div>
          <div className="header-sample">
            <i className="fa fa-chevron-circle-left" onClick={this.props.history.goBack}></i>
          </div>
          {this.state.showSnack ? <div className="snackbar2 show">{this.state.messageSnack}</div> : ""}
          <DependantHeaderSample titleCall={true} title="Reschedule to same day"></DependantHeaderSample>
        </div>

        <Container>
          <Row className="m-t-10">
            <Col>
              <span className="deep-pink-color font-size-ml bold"> Date & Time:</span> &nbsp;{" "}
              {this.formatDate(new Date(this.state.date))
                .toString()
                .concat(" ")
                .concat(this.formatAMPM(new Date(JSON.parse(localStorage.getItem("AppointmentDate")))))}
            </Col>
          </Row>
          <Row className="m-t-10">
            <Col xs={7} md={7}>
              {" "}
              <span className="deep-pink-color font-size-ml bold p-t-3"> Select Reschedule Time Slot: </span>
            </Col>

            <Col xs={5} md={4}>
              <TimePicker start="06:00" end="13:00" step={60} onChange={(date) => this.validateTime(date)} value={this.state.currentTime} />
            </Col>
          </Row>
          {this.state.showOTPVerification && (
            <Row className="m-t-50">
              <Col xs={12} md={12}>
                <Form onSubmit={(e) => this.handleSubmit(e)}>
                  <Form.Group>
                    <Form.Label htmlFor="phoneNumber">Phone Number</Form.Label>
                    <Form.Control
                      type="number"
                      name="phoneNumber"
                      value={this.state.phoneNumber}
                      placeholder="Enter Phone Number"
                      disabled={true}
                      onChange={(e) => this.handleChange(e)}
                    />
                    {errors.phoneNumber && <span className="font-size-sm gray-color">{errors.phoneNumber}</span>}
                  </Form.Group>

                  {this.state.sendOTP && (
                    <Form.Group>
                      <Form.Label htmlFor="otp">Enter OTP</Form.Label>
                      <Form.Control type="password" name="otp" placeholder="OTP" onChange={(e) => this.verifyOtp(e)} />
                    </Form.Group>
                  )}
                  <div className="p-b-10">
                    {this.state.sendOTP ? (
                      <>
                        <Button variant="primary" type="submit" className="text-align-center w-100" disabled={errors.phoneNumber}>
                          {" "}
                          Verify OTP{" "}
                        </Button>
                        <div
                          className="text-align-center p-t-10 base-color font-size-smd bold"
                          onClick={(e) => this.sendOTP(e)}
                          disabled={errors.phoneNumber}
                        >
                          Resend OTP
                        </div>
                      </>
                    ) : (
                      <Button
                        variant="primary"
                        type="button"
                        onClick={(e) => this.sendOTP(e)}
                        disabled={errors.phoneNumber}
                        className="text-align-center w-100"
                      >
                        {" "}
                        Send OTP{" "}
                      </Button>
                    )}
                  </div>
                </Form>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    );
  }
}

export default DependantRescheduleToSameDay;
